import { render, staticRenderFns } from "./SysBmAdModal.vue?vue&type=template&id=19e6c200&"
import script from "./SysBmAdModal.vue?vue&type=script&lang=js&"
export * from "./SysBmAdModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e6c200')) {
      api.createRecord('19e6c200', component.options)
    } else {
      api.reload('19e6c200', component.options)
    }
    module.hot.accept("./SysBmAdModal.vue?vue&type=template&id=19e6c200&", function () {
      api.rerender('19e6c200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/ad/modules/SysBmAdModal.vue"
export default component.exports